import React from "react";
import ModalEditFundingRound from "../../../company/profil/financial/modal/modal-edit-funding-round-and-amount";
import * as T from "../../../../../controller/company-ctr/types/types-company-page";

export default function ModalFundingRound(
  props: T.IpropEditFundingRoundAandAmount
) {
  return <ModalEditFundingRound {...props} />;
}
